/**
 * Аккордеоны шаблонов курсов: программа обучения и блок вопросов.
 *
 * Этап 6 §0, группа 4. Перенесён инлайн-блок, который лежал ДВАЖДЫ:
 *   `page-basic-coaching.php:955`      184 строки
 *   `page-new-basic-course.php:1711`   199 строк
 *
 * 🔴 Почему один модуль, а не два: тела блоков ИДЕНТИЧНЫ. Проверено
 * не на глаз — сверкой через `.tmp/cmp-two.cjs`: после снятия всех
 * пробелов обе версии дали ровно 2934 символа и совпали посимвольно.
 * Все 22 построчных расхождения оказались форматированием — `if(`
 * против `if (` и перенос полей объекта на отдельные строки.
 *
 * Страницы-потребители (полный список из БД, включая черновики —
 * запрос по `_wp_page_template`, не по карте тестов):
 *   /basic-coaching/          Основы коучинга
 *   /pkmu/                    ПКМУ
 *   /prodvinutyy-coaching/    Продвинутый коучинг
 *
 * ⚠️ Из четырёх функций исходного блока перенесены ДВЕ.
 * Разбор двух оставшихся — ниже, у места, где они были.
 */

/**
 * Раскрытие пунктов программы обучения.
 *
 * Поведение «ДО» замерено на живых страницах: 7 пунктов на
 * `/basic-coaching/`, 19 на `/pkmu/`, 12 на `/prodvinutyy-coaching/`,
 * клик по кнопке добавляет класс. Накопители совпадают с числом
 * кнопок — висячих `.program-item` без кнопки нет.
 *
 * ⚠️ `btn` берётся без проверки на null — как в исходнике. Если
 * вёрстка отдаст `.program-item` без кнопки, здесь будет исключение,
 * и оно оборвёт остальные инициализации. Сохранено 1:1 сознательно:
 * перенос не меняет поведения. Замена на опциональный вызов — это
 * уже правка логики, её нужно делать отдельно и со своей приёмкой.
 */
function initProgramItems() {
    const programs = document.querySelectorAll('.program-item');
    if (!programs.length) return;

    programs.forEach((program) => {
        const btn = program.querySelector('.program-item__btn');
        btn.addEventListener('click', () => {
            program.classList.toggle('program-item--open');
        });
    });
}

/**
 * Раскрытие вопросов блока FAQ.
 *
 * Замер «ДО»: 9 вопросов на `/basic-coaching/`, 4 на `/pkmu/`,
 * 5 на `/prodvinutyy-coaching/`; клик переключает `faq-item--active`.
 */
function initFaqItems() {
    const questions = document.querySelectorAll('.faq-item');
    if (!questions.length) return;

    questions.forEach((question) => {
        const btn = question.querySelector('.faq-item__btn');
        btn.addEventListener('click', () => {
            question.classList.toggle('faq-item--active');
        });
    });
}

/*
 * 🗑 НЕ перенесены две функции исходного блока — они мёртвые.
 *
 * 1. Попап преподавателей (`initTeacherPopup`, ~45 строк, включая
 *    три биографии в HTML-строках).
 *
 *    👤 Разметка и её CSS удалены владельцем 2026-10-15 — backlog §0.11.
 *    Разбор ниже сохранён: он объясняет, на каком основании признали
 *    код мёртвым, и это тот же метод, который понадобится в следующий раз.
 *
 *    Открывался по `.js-popup-teacher-trigger`. Триггеров НЕТ:
 *      - в разметке 3 живых страниц — 0 (поиск `class="…` по HTML
 *        от `curl`, а не подстроки: подстрока находит сам этот код);
 *      - в `post_content` всех записей и страниц БД — 0;
 *      - в `postmeta` — 0;
 *      - в шаблонах темы — только в самих двух скриптах.
 *
 *    ⚠️ На момент разбора САМА разметка попапа на страницу уходила:
 *    её подключал `get_template_part` из обоих шаблонов. То есть
 *    отдавался блок, который нечем открыть, а три биографии были
 *    захардкожены строками в скрипте — своих ACF-полей у попапа
 *    не оказалось вовсе.
 *
 *    🔴 Ловушка при удалении: в ACF есть похожее по имени поле
 *    `teachers_block` → `teachers`. Это ЖИВОЙ слайдер преподавателей
 *    (48 вхождений в разметке `/basic-coaching/`, 51 на `/pkmu/`),
 *    он к попапу отношения не имеет и остался на месте.
 *
 * 2. Тултипы карточек тарифов (`initCardTooltip`, ~11 строк).
 *
 *    Работал по `.service-price__card-feature--tooltip`. В разметке
 *    этого класса нет НИ НА ОДНОЙ из шести страниц, выводящих
 *    `tariff_block`: `/basic-coaching/`, `/pcc/`, `/promotion-basics/`,
 *    `/silavslove/`, `/stratsession/`, `/pkmu/`,
 *    `/prodvinutyy-coaching/` — все дали 0.
 *
 *    🔴 Ловушка, на которой разбор почти сорвался: в `postmeta`
 *    класс встречается 15 раз, одно из вхождений — на ОПУБЛИКОВАННОЙ
 *    странице #34359 в поле `tariff_block_tariff_items_0_descr`
 *    (остальные 14 — ревизии). Выглядело как живое использование.
 *    Но `page-basic-coaching.php` не вызывает `get_field('tariff_block')`
 *    вообще — поле осиротело после смены вёрстки блока тарифов.
 *    Поэтому класс лежит в БД, а в HTML не попадает.
 *    Ровно тот же случай, что с `stock_block` на Этапе 1.
 *
 * 3. Также не перенесены 225 строк закомментированного кода:
 *    два таймера обратного отсчёта на даты августа и сентября 2025
 *    и подключение видео вебинара. Их вызовы в исходнике тоже были
 *    закомментированы. Живого кода в блоке было 82 строки из 199.
 */

/**
 * Точка входа. Вызывается из `src/main.js` отложенно — после
 * готовности DOM, поэтому своей обёртки `DOMContentLoaded`
 * (как было в инлайне) здесь не нужно.
 */
export default function CourseAccordions() {
    initProgramItems();
    initFaqItems();
}
